import { isDeploymentFeatureEnabled } from "@/shared/config/deployment-features"
import { FoundationAccrualModal } from "@/features/foundation-accrual"
import { RecreateApiKeyModal, UpdateApiKeyModal } from "@/features/update-api-key"
import { DeleteFormbuilderFieldModal } from "@/features/update-formbuilder-field"
import { CreateGroupModal, DeleteGroupModal, GroupAccrualModal, GroupVisibilityACLModal, UserVisibilityACLModal } from "@/features/update-group"
import { CreateInvitationModal, DeleteInvitationModal, InspectInvitationModal } from "@/features/update-invitation"
import { ApproveJobApplicationModal, InspectJobApplicationModal, RejectJobApplicationModal } from "@/features/update-job-application"
import { CreatePartnerDiscountModal, DeletePartnerDiscountModal, UpdatePartnerDiscountModal } from "@/features/update-partner-discount"
import { CreateUserIntegrationModal, DeleteUserIntegrationModal, UpdateUserIntegrationModal } from "@/features/update-user-integration"
import { CreateVacancyModal, DeleteVacancyModal, EditVacancyFormModal, UpdateVacancyModal } from "@/features/update-vacancy"
import { UserAccrualModal } from "@/features/user-accrual"
import { UserBroadcastModal } from "@/features/user-broadcast"
import { TransferBonusesModal } from "@/features/trading"
import { CreateInvoiceModal } from "@/features/create-invoice"
import { ChangeUserGroupModal } from "@/features/change-user-group"
import { ConfirmBlockModal } from "@/features/user-block"
import { ConfirmUserDeleteRestoreModal } from "@/features/user-delete-restore"
import { FillProfileModal } from "@/features/fill-profile"

export const Modals = () => {
    return (
        <>
            <CreatePartnerDiscountModal />
            <UpdatePartnerDiscountModal />
            <DeletePartnerDiscountModal />
            <UserAccrualModal />
            <UserBroadcastModal />
            <ChangeUserGroupModal />
            <ConfirmBlockModal />
            <ConfirmUserDeleteRestoreModal />
            <FoundationAccrualModal />
            <CreateVacancyModal />
            <DeleteVacancyModal />
            <UpdateVacancyModal />
            <InspectJobApplicationModal />
            <ApproveJobApplicationModal />
            <RejectJobApplicationModal />
            <CreateUserIntegrationModal />
            <DeleteUserIntegrationModal />
            <UpdateUserIntegrationModal />
            <UpdateApiKeyModal />
            <RecreateApiKeyModal />
            <DeleteFormbuilderFieldModal />
            <EditVacancyFormModal />
            <CreateGroupModal />
            <DeleteGroupModal />
            <GroupAccrualModal />
            <GroupVisibilityACLModal />
            <UserVisibilityACLModal />
            <DeleteInvitationModal />
            <CreateInvitationModal />
            <InspectInvitationModal />
            {isDeploymentFeatureEnabled('trading') && <TransferBonusesModal />}
            <CreateInvoiceModal />
            <FillProfileModal />
        </>
    )
}